import { Button, Card, Flex, Space, Stack, Text, Title } from '@mantine/core';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { utils, writeFile } from 'xlsx';
import { useMutation } from '@tanstack/react-query';
import { listLadderboard } from '../../services/report-gamification';
import LabelDate from '../../components/fragments/LabelDate';
import DataTables from '../../components/elements/DataTables';
import LoadingIllustration from '../../components/fragments/IllustrationState/LoadingIllustration';
import { Route, useHistory } from 'react-router-dom';

export default function LadderboardTable() {
  const [proses, setProses] = useState(false);
  const [data, setData] = useState([]);
  const [binusianId, setBinusianId] = useState(null);
  const renderDate = (item, key) => <LabelDate date={item[key]} />;
  let history = useHistory();

  const renderConvertExcel = () => {
    const filename = `List Ladderboard - download at ${dayjs().toLocaleString()}`;

    const wb = utils.book_new();

    // Convert the JSON data to a worksheet
    const ws = utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    utils.book_append_sheet(wb, ws, 'Mission');

    // Write the workbook to a file
    // This will trigger a file download in the browser
    writeFile(wb, `${filename}.xlsx`);
  };

  const columnMission = [
    {
      heading: 'Name',
      props: (item) => (
        <span>{item.namaUser === '' ? 'Unknown' : item.namaUser}</span>
      ),
      id: 'namaUser',
      sortable: true
    },
    {
      heading: 'Email',
      props: 'email',
      id: 'email',
      sortable: true
    },
    {
      heading: 'Point Achived',
      props: 'totalPoint',
      id: 'totalPoint',
      sortable: true
    },
    {
      heading: 'Level',
      props: (item) => (
        <div
          dangerouslySetInnerHTML={{
            __html: item.level
          }}
        />
      ),
      id: 'level',
      sortable: true
    },

    {
      heading: 'Action',
      props: (item) => (
        <Space>
          <Button
            color="purple"
            radius="md"
            onClick={() => {
              // go to page /management/report-gamification/overview-binusian
              history.push(
                `/management/report-gamification/overview-binusian?bid=${item.binusianID}`
              );
            }}
          >
            View Detail
          </Button>
        </Space>
      )
    }
  ];

  useEffect(() => {
    handleOnClick(null);
  }, []);

  const handleOnClick = (passSearch) => {
    setProses(true);
    const payload = {
      binusianName: passSearch
    };
    fetchCategory.mutate(payload);
  };

  const fetchCategory = useMutation({
    mutationFn: listLadderboard,
    onSuccess: (data) => {
      setData(data?.data?.data);
    },
    onError: (error: any) => {
      alert(error);
    },
    onSettled: () => {
      setProses(false);
    }
  });
  return (
    <Card>
      <Flex
        style={{
          justifyContent: 'space-between'
        }}
      >
        <Stack mb={10} gap={'xs'}>
          <Title order={4}>Report Gamification - Leaderboard</Title>
          <Text size="sm">
            This is the leaderboard for the user who has the most point.
          </Text>
        </Stack>
        <Flex>
          <Button
            color="teal"
            radius="md"
            onClick={() => {
              renderConvertExcel();
            }}
          >
            Download
          </Button>
          {binusianId && (
            <Button
              color="gray"
              radius="md"
              ml={10}
              onClick={() => {
                setBinusianId(null);
                handleOnClick(null);
              }}
            >
              Back
            </Button>
          )}
        </Flex>
      </Flex>
      {data.length === 0 && proses ? (
        <LoadingIllustration />
      ) : (
        <DataTables columns={columnMission} loading={false} data={data || []} />
      )}
    </Card>
  );
}
